import React, { useEffect } from 'react';
import Modal from 'react-modal';
import { AnyIfEmpty } from 'react-redux';

const Popup = (props: AnyIfEmpty<object>) => {
    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        },
    };

    function closeModal() {
        props.setOpen(false);
        props.onCloseModal && props.onCloseModal();
    }

    // Prevent background scroll when modal is open
    useEffect(() => {
        if (props.open) {
            document.body.style.overflow = 'hidden'; // lock scroll
        } else {
            document.body.style.overflowY = 'auto'; // restore scroll
        }

        // Cleanup on unmount
        return () => {
            document.body.style.overflowY = 'auto';
        };
    }, [props.open]);

    return (
        <Modal
            isOpen={props.open}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Modal"
            className={props.className || ''}
            ariaHideApp={false}
            overlayClassName={props.className}
            shouldCloseOnOverlayClick={false || props.shouldCloseOnOverlayClick}>
            {props.bodyData}
        </Modal>
    );
};

export default Popup;
